import { createSelector } from 'reselect'

const getStorefrontOwnerData = state => state.storefront.owner
const getLessonsData = state => state.lessons

const storefront_owner_view_selector = createSelector(
	[ getStorefrontOwnerData, getLessonsData ],
	(ownerState, lessonsState) => {

		const lessons = ownerState.lessons.entities.map(id => lessonsState[id])

		return {
			more: ownerState.lessons.more,
			canLoadMore: lessons.length !== 0 && ownerState.lessons.more,
			searched: ownerState.lessons.searched,
			lessons,
			isDragging: ownerState.lessons.isDragging,
		}
	}
)

export default storefront_owner_view_selector
